import { Separator as RadixSeparator } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const Separator = withMappingProps(RadixSeparator);
//# sourceMappingURL=separator.js.map